export default {
    "id": "emergency",
    "name": "醫療資源",
    "style": "dropdown-columns",
    "children": [
        {
            "id": "emergency-services",
            "name": "緊急醫療及夜診服務",
            "children": [
                {
                    "id": "emergency-1",
                    "name": "提供流感快速測試的診所名單",
                    "href": "https://www.finddoc.com/health/news/%E6%8F%90%E4%BE%9B%E6%B5%81%E6%84%9F%E5%BF%AB%E9%80%9F%E6%B8%AC%E8%A9%A6%E7%9A%84%E8%A8%BA%E6%89%80%E5%90%8D%E5%96%AE/"
                },
                {
                    "id": "emergency-2",
                    "name": "緊急醫療服務",
                    "href": "https://www.finddoc.com/emergency-se~rvices"
                }
            ]
        },
        {
            "id": "others",
            "name": "其他醫療資源",
            "children": [
                {
                    "id": "emergency-3",
                    "name": "13 價肺炎疫苗資助計劃的診所名單",
                    "href": "https://www.finddoc.com/doctors/pcv13subsidy"
                },
                {
                    "id": "emergency-4",
                    "name": "公立醫院專科門診輪候時間",
                    "href": "https://www.finddoc.com/%E5%85%AC%E7%AB%8B%E9%86%AB%E9%99%A2%E5%B0%88%E7%A7%91%E9%96%80%E8%A8%BA%E8%BC%AA%E5%80%99%E6%99%82%E9%96%93"
                }
            ]
        }
    ]
}